import HttpClient from '@/utils/httpClient'

import {
  ActualiseShiftEarningsRequest,
  ActualiseShiftEarningsResponse,
  CallUpdateScheduleForDriverRequest,
  CallUpdateScheduleTaskRequest,
  SheduleResponse,
} from 'rikroot-types/worker.pb'

export class WorkerRepository extends HttpClient {
  async updateScheduleTask(data: CallUpdateScheduleTaskRequest): Promise<SheduleResponse> {
    return await this.post('/worker/updateScheduleTask', data)
  }

  async updateScheduleForDriverTask(
    data: CallUpdateScheduleForDriverRequest,
  ): Promise<SheduleResponse> {
    return await this.post('/worker/updateScheduleForDriverTask', data)
  }

  async updateShiftEarnings(
    data: ActualiseShiftEarningsRequest,
  ): Promise<ActualiseShiftEarningsResponse> {
    return await this.post('/worker/shift/actualise-earnings', data)
  }
}
